const FirstAnime = () => {
  const firsts = document.getElementsByClassName('js-first-animation');
  if(!firsts) return;
  Array.from(firsts).forEach(first => {
    first.classList.add('active');
  });
}

window.addEventListener('load', () => {
  FirstAnime();
})